import type { NetworkPayload } from "../../../composites";

const getDualApprovalDetailPath = (uuid: API.DualApprovalId) => {
  return `approval_requests/${encodeURIComponent(String(uuid))}/`;
};

export const API = {
  fetchDualApprovals: (
    pageNumber?: number,
    pageSize?: number,
    model?: string,
    modelNotIn?: string,
  ): NetworkPayload => {
    const params = new URLSearchParams();
    if (pageNumber) params.set("page", String(pageNumber));
    if (pageSize) params.set("per_page", String(pageSize));
    if (model) params.set("model", model);
    if (modelNotIn) params.set("model_not_in", modelNotIn);
    const query = params.toString();
    const url = query ? `approval_requests?${query}` : "approval_requests";
    return {
      url,
      options: {
        method: "GET",
        disableCaching: true,
      },
    };
  },

  approveDualApproval: (uuid: API.DualApprovalId): NetworkPayload => ({
    url: getDualApprovalDetailPath(uuid),
    options: {
      method: "POST",
      payload: { action: "approve" },
    },
  }),

  rejectDualApproval: (
    uuid: API.DualApprovalId,
    note?: string,
  ): NetworkPayload => ({
    url: getDualApprovalDetailPath(uuid),
    options: {
      method: "POST",
      payload: { action: "reject", ...(note ? { note } : {}) },
    },
  }),

  fetchHistoryDualApprovals: (
    pageNumber?: number,
    pageSize?: number,
  ): NetworkPayload => {
    const url =
      pageNumber && pageSize
        ? `approval_requests/history?page=${pageNumber}&per_page=${pageSize}`
        : "approval_requests/history";
    return {
      url,
      options: {
        method: "GET",
        disableCaching: true,
      },
    };
  },

  fetchDualApprovalById: (uuid: API.DualApprovalId): NetworkPayload => ({
    url: getDualApprovalDetailPath(uuid),
    options: {
      method: "GET" as const,
      disableCaching: true,
    },
  }),

  cancelDualApproval: (uuid: API.DualApprovalId): NetworkPayload => ({
    url: `${getDualApprovalDetailPath(uuid)}cancel/`,
    options: {
      method: "POST",
      payload: {},
      isJsonResponse: false,
    },
  }),

  fetchTemplateDualApprovals: (
    pageNumber?: number,
    pageSize?: number,
  ): NetworkPayload => {
    return API.fetchDualApprovals(
      pageNumber,
      pageSize,
      "BulkPaymentTemplateVersion",
    );
  },
};
